export const googleClientId = '345350504609-1moo0gfi27h0jj2qaim5ed1iohgprs99.apps.googleusercontent.com';
export const googleScopes = 'profile email https://www.googleapis.com/auth/drive';